import React from 'react'
import router from './router/router';
import Router from './router/router';

function App() {
  return <Router />;
}

export default App;